/**
 * scrolls to position in window
 * @method smoothScrollTo
 * @param {object} element
 * @param {object} smoothScrollOptions
 * @param {number} smoothScrollOptions.left
 * @param {number} smoothScrollOptions.top
 * @param {string|undefined} smoothScrollOptions.behavior - smooth|auto
 * @returns {undefined}
 */
export const smoothScrollOnElement = (element, scrollToOptions = {}) => {
  if (__CLIENT__) {
    const scrollLeft = scrollToOptions?.left ?? 0;
    const scrollTop = scrollToOptions?.top ?? 0;
    const scrollBehavior = scrollToOptions?.behavior ?? 'auto';
    try {
      (element || window).scrollTo({
        left: scrollLeft,
        top: scrollTop,
        behavior: scrollBehavior,
      });
    } catch (err) {
      // this should catch edge, IE, Safari on iOS
      // Reverts to none smooth scroll
      window.scrollTo(scrollLeft, scrollTop);
    }
  }
};

/**
 * scrolls to position in window
 * @method smoothScrollTo
 * @param {object} smoothScrollOptions
 * @param {number} smoothScrollOptions.left
 * @param {number} smoothScrollOptions.top
 * @param {string|undefined} smoothScrollOptions.behavior - smooth|auto
 * @returns {undefined}
 */
export const smoothScrollTo = (scrollToOptions = {}) => {
  if (__CLIENT__) {
    return smoothScrollOnElement(window, scrollToOptions);
  }
};

/**
 * scrolls to top position in window
 * @method smoothScrollToTop
 * @returns {undefined}
 */
export const smoothScrollToTop = () => {
  if (__CLIENT__) {
    return smoothScrollOnElement(window, { top: 0, behavior: 'smooth' });
  }
};
